import { RaceLap, TelemetryLapData } from '../models/TelemetryData';

export interface SectorDistances {
  s1End: number | null;
  s2End: number | null;
}

/**
 * Compute sector boundary distances by finding where the baseline lap's
 * telemetry time (m field) crosses the sector cumulative times.
 * sec1/sec2/sec3 are individual durations: sec1 + sec2 + sec3 ≈ time.
 */
export function computeSectorDistances(
  lap: RaceLap,
  telemetry: TelemetryLapData
): SectorDistances | null {
  const frames = telemetry.t;
  const distances = Object.keys(frames)
    .map(Number)
    .sort((a, b) => a - b);

  const s1End = lap.sec1 > 0
    ? findDistanceAtTime(frames, distances, lap.sec1)
    : null;

  const s2End = lap.sec1 > 0 && lap.sec2 > 0 && lap.sec3 > 0
    ? findDistanceAtTime(frames, distances, lap.sec1 + lap.sec2)
    : null;

  // Return null only if we have no boundaries at all
  if (s1End === null && s2End === null) return null;

  return { s1End, s2End };
}

function findDistanceAtTime(
  frames: TelemetryLapData['t'],
  distances: number[],
  targetTime: number
): number | null {
  for (let i = 1; i < distances.length; i++) {
    const prevDist = distances[i - 1];
    const currDist = distances[i];
    const prevTime = frames[String(prevDist)].m;
    const currTime = frames[String(currDist)].m;

    if (prevTime <= targetTime && currTime >= targetTime) {
      // Linear interpolation
      const ratio = (targetTime - prevTime) / (currTime - prevTime);
      return prevDist + ratio * (currDist - prevDist);
    }
  }
  return null;
}
